import Vue from 'vue'

import {
    forEach as _forEach,
    orderBy as _orderBy,
} from 'lodash'

import CityModel from '@/models/CityModel'

// -----------------------------------------------------------------------------

const state = {
    cities: {},
    isLoading: false,
}

const getters = {
    getCities: state => {
        return _orderBy(state.cities, item => Number(item.sort) || 0, ['asc'])
    },

    getCity: state => cityId => {
        return state.cities[cityId] || null
    },
}

const mutations = {
    setCities(state, payload) {
        state.cities = {}

        _forEach(payload, item => {
            const City = new CityModel(item)

            Vue.set(state.cities, City.id, City)
        })
    },

    setCity(state, payload) {
        const City = new CityModel(payload)

        Vue.set(state.cities, City.id, City)
    },

    setIsLoading(state, payload) {
        state.isLoading = !!payload
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}
